export const build = { date:"2026-05-19.1807", stage:"alpha" }
